import { GROUP_FEATURE_USAGE_FETCH_REQUEST } from 'store/constants/groupFeatureUsageTypes';

export function fetchGroupFeatureUsage() {
  return {
    type: GROUP_FEATURE_USAGE_FETCH_REQUEST,
  };
}
